import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e17d866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "welcome-inner pt-10" }
const _hoisted_2 = { class: "has-text-centered mt-4" }
const _hoisted_3 = { class: "beta has-text-centered" }
const _hoisted_4 = {
  "background-color": "green-54",
  "text-color": "neutral-100",
  class: "mt-4"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "mx-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider my-6 px-2" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "notes has-text-centered" }
const _hoisted_9 = { class: "icon-round" }
const _hoisted_10 = ["innerHTML"]

import { useRouter } from 'vue-router'
import { onMounted, ref, watch } from 'vue'

import TestnetBackground from '@/assets/testnet-welcome.png'
import Button from '@/popup/components/shared/Button.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import ScrollToBottom from '@/popup/components/shared/Scroll/ScrollToBottom.vue'
import { useFixedHeader } from '@/popup/compositions/useFixedHeader'


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeInfo',
  setup(__props) {

const router = useRouter()

const bottomRef = ref<InstanceType<typeof HTMLElement>>()
const contentRef = ref<InstanceType<typeof HTMLElement>>()
const scrollOffset = ref<number>(0)
const showScrollButton = ref(true)
const { onContentScroll, bottomThresholdOffset } = useFixedHeader(
  scrollOffset,
  contentRef
)

const scrollToBottom = () => {
  if (bottomRef.value) {
    bottomRef.value.scrollIntoView({ behavior: 'smooth' })
  }
}

const info = [
  {
    icon: 'warning-triangle',
    text: 'welcome.mainnet.warning',
  },
  {
    icon: 'trash',
    text: 'welcome.mainnet.trash',
  },
  {
    icon: 'hand-right-outline',
    text: 'welcome.mainnet.help',
  },
]

watch(bottomThresholdOffset, value => {
  showScrollButton.value = value > 64
})

onMounted(() => {
  onContentScroll()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: "welcome-wrapper scrollbar-wrapper px-6",
      ref_key: "contentRef",
      ref: contentRef,
      style: _normalizeStyle({
      backgroundImage: `url(${_unref(TestnetBackground)})`,
      width: 'inherit',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
    }),
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onContentScroll) && _unref(onContentScroll)(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SvgIcon, {
          class: "has-text-centered mr-2",
          name: "up-cube",
          width: "97",
          height: "101"
        }),
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('welcome.testnet.hello')), 1 /* TEXT */),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('welcome.testnet.beta')), 1 /* TEXT */),
        _createElementVNode("lukso-tag", _hoisted_4, _toDisplayString(_ctx.$t('welcome.mainnet.on_mainnet')), 1 /* TEXT */),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('welcome.mainnet.announce'),
          class: "announce has-text-centered mt-4"
        }, null, 8 /* PROPS */, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('welcome.testnet.notes')), 1 /* TEXT */),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(info, ({ icon, text }) => {
          return _createElementVNode("div", {
            class: "info mt-4",
            key: text
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(SvgIcon, {
                name: icon,
                color: "var(--neutral-20)",
                width: "24",
                height: "24"
              }, null, 8 /* PROPS */, ["name"])
            ]),
            _createElementVNode("p", {
              innerHTML: _ctx.$t(text),
              class: "info-text"
            }, null, 8 /* PROPS */, _hoisted_10)
          ])
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("div", {
        ref_key: "bottomRef",
        ref: bottomRef,
        class: "mb-6 mt-8"
      }, [
        _createVNode(Button, {
          "data-testid": "join-testnet-button",
          variant: "primary",
          "is-full-width": true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/welcome')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('welcome.mainnet.join')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ], 512 /* NEED_PATCH */)
    ], 36 /* STYLE, NEED_HYDRATION */),
    _createVNode(ScrollToBottom, {
      "show-scroll-button": showScrollButton.value,
      onScrollToBottom: scrollToBottom
    }, null, 8 /* PROPS */, ["show-scroll-button"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})